"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentLoopBehaviours = void 0;
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var BehaviourBuilder_1 = require("../BehaviourBuilder");
var ContentLoopActions_1 = require("./ContentLoopActions");
var Types_1 = require("ContentTokens/Models/inputs/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BehaviourName;
(function (BehaviourName) {
    BehaviourName["SetContentLoopVariable"] = "setContentLoopVariable";
    BehaviourName["RemoveContentLoopVariable"] = "removeContentLoopVariable";
    BehaviourName["DropContentLoopVariable"] = "dropContentLoopVariable";
    BehaviourName["BackspaceAtContentLoopStart"] = "backspaceAtContentLoopStart";
    BehaviourName["DeleteAtContentLoopEnd"] = "deleteAtContentLoopEnd";
})(BehaviourName || (BehaviourName = {}));
var getContentLoopBehaviours = function (di) {
    return {
        onSetContentLoopVariable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.SetContentLoopVariable)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "contentLoop", action: EditorTypes_1.ContentLoopActionType.SetContentLoopVariable })
            .doAction(function (event, editor) {
            (0, ContentLoopActions_1.setContentLoopVariable)(editor, event.data.path, event.data.variable);
            return true;
        }),
        onRemoveContentLoopVariable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.RemoveContentLoopVariable)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "contentLoop", action: EditorTypes_1.ContentLoopActionType.RemoveContentLoopVariable })
            .doAction(function (event, editor) {
            (0, ContentLoopActions_1.removeContentLoopVariable)(editor, event.data.path);
            return true;
        }),
        onDropContentLoopVariable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.DropContentLoopVariable)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "contentLoop", action: EditorTypes_1.ContentLoopActionType.DropContentLoopVariable })
            .doAction(function (event, editor) {
            var variable = event.data.variable;
            (0, ContentLoopActions_1.dropContentLoopVariable)(editor, event.data.path, new Types_1.RepeatingTokenInput(variable.apiName, variable.name, variable.childObjectType, variable.childPropertyLabel, SubstitutionTokenFactory_1.default.fromLegacyApiToken(variable)));
            return true;
        }),
        onBackspaceAtContentLoopStart: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.BackspaceAtContentLoopStart)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(kaleidoscope_1.KeyType.Backspace)
            .selectionIsCollapsed()
            .isOfAncestry("contentLoopBody")
            .doAction(function (event, editor) {
            if ((0, ContentLoopActions_1.backspaceAtContentLoopStart)(editor)) {
                event.preventDefault();
                return true;
            }
        }),
        onDeleteAtContentLoopEnd: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.DeleteAtContentLoopEnd)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(kaleidoscope_1.KeyType.Delete)
            .selectionIsCollapsed()
            .isOfAncestry("contentLoopBody")
            .doAction(function (event, editor) {
            if ((0, ContentLoopActions_1.deleteAtContentLoopEnd)(editor)) {
                event.preventDefault();
                return true;
            }
        }),
    };
};
exports.getContentLoopBehaviours = getContentLoopBehaviours;
